import { Component, Prop } from "vue-property-decorator";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal";
import { Item } from "@/types/Component";
import Modal from "@/assets/common/Modal/Modal.vue";
import { toCamel } from 'snake-camel';

type ShippingDestinations = {
    shippingDestinations: Item[]
}

@Component({
    components: {
        Modal
    }
})
export default class ShippingDestinationSelectModal extends ItemSelectModal {
    @Prop({
        default: () => "出荷先"
    })
    declare itemKindName: string

    @Prop({
        default: () => "/admin/shipping_destinations"
    })
    declare apiPath: string;

    @Prop({default: () => true})
    declare multiple: boolean

    private withHidden = false
    private allCandidates: Item[] = []
    private showEditForm = false
    private modeType = ''
    private newItem: Item = {
        id: '',
        name: '',
        isHidden: false
    }
    private updatingTarget: Item | null = null
    declare selectedValue: Item[]

    async fetchCandidates(): Promise<Item[]> {
        const res = await this.$apiClient.doRequest('get', `${this.apiPath}?with_hidden=true`)
        this.allCandidates = (toCamel(res) as ShippingDestinations).shippingDestinations
        if(this.multiple){
            this.selectedValue = this.selectedValue.map(selectedItem => {
                return this.allCandidates.find(item => item.id === selectedItem.id) as Item
            })
        }
        return this.filteredHiddenItem()
    }

    filteredHiddenItem() {
        if(this.withHidden) {
            return this.allCandidates
        } else {
            return this.allCandidates.filter(item => !item.isHidden)
        }
    }

    doFilter() {
        this.candidates = this.filteredHiddenItem()
    }

    private addItem() {
        this.modeType = 'add'
        this.updatingTarget = null
        this.newItem = {
            id: '',
            name: '',
            isHidden: false
        }
        this.showEditForm = true
    }

    private editItem(item: Item) {
        this.modeType = 'edit'
        this.newItem = {
            id: item.id,
            name: item.name,
            isHidden: item.isHidden
        }
        this.updatingTarget = item
    }

    private closeEditItem() {
        this.modeType = ''
        this.newItem = {
            id: '',
            name: '',
            isHidden: false
        }
        this.showEditForm = false
        this.updatingTarget = null
    }

    private endEdit() {
        this.closeEditItem()
        this.mode = 'select'
    }

    private updateHidden(item: Item, e: Event) {
        this.modeType = 'hidden'
        const displayMessage = item.isHidden? '表示状態に戻し' : '非表示にし'
        const result = window.confirm(`${item.name}を${displayMessage}ます。よろしいですか？`)
        if(!result) {
            e.preventDefault()
            return false;
        }
        this.doUpdate(item)
    }

    private saveData() {
        // 名前の長さ
        if(this.newItem.name.length > 255){
            window.alert(`出荷先名は255文字以内で入力してください（現在は${this.newItem.name.length}文字）`)
            return false
        }
        this.doUpdate(this.newItem)
    }

    private doUpdate(item: Item){
        let method: "post" | "put" = 'post'
        let url = ''
        let message = ''
        let data: {
            name: string;
            is_hidden?: boolean;
        } = {name: ''}

        switch (this.modeType) {
            case 'add':
                url = this.apiPath
                method = 'post'
                message = '保存しました。'
                data = {
                    name: item.name
                }
                break
            case 'edit':
                url = `${this.apiPath}/${item.id}`
                method = 'put'
                message = '変更を保存しました。'
                data = {
                    name: item.name,
                    is_hidden: item.isHidden
                }
                break
            case 'hidden':
                url = `${this.apiPath}/${item.id}`
                method = 'put'
                message = item.isHidden? '表示状態に戻しました。' : '非表示にしました。'
                data = {
                    name: item.name,
                    is_hidden: !item.isHidden
                }
                break
            default:
                return false
        }
        this.$apiClient.doRequest(method, url, data)
        .then((res)=>{
          this.$toasted.success(message)
          this.fetchCandidates().then(items => {
            this.doFilter()
            this.closeEditItem()
            this.$emit('updateItem', item)
          })
        })
        .catch(()=>{
          this.$toasted.error('保存に失敗しました。')
        })
    }

    private checkSelectedValue(item: Item) {
        return !!this.selectedValue.find(selectedItem => selectedItem.id === item.id)
    }
}
